export default __webpack_public_path__ + "static/karina_rojek-c646b17bc82f2bb41c323d1546ac67dc.jpg";